export default __webpack_public_path__ + "static/media/fondo5.c9f19284.png";